import Auth from 'lib/Core/Backend/Controllers/Auth';
import Notify from 'lib/Utils/Alert';
import { useMemo, useRef, useState,useEffect } from 'react';
import { Card, Col, Container, Form, InputGroup, Modal, Row } from "react-bootstrap";
import ReactNotificationAlert from 'react-notification-alert';
import { useHistory } from "react-router-dom";
import "../../../src/custom.css";
import AuthData from "../../lib/Core/AuthData";
import { MotionCard } from './MotionStrap';

// Security groups list
const securityGroups = [
    "SYSTEM_MANAGER",
    "INTERNAL_MANAGER",
    "INTERNAL",
    "PRODUCT_MANAGER",
    "SUPPLIER_MANAGER",
    "COMMERCIAL_MANAGER",
    "ACCOUNTANT_MANAGER",
    "CUSTOMER_SERVICE"
];
const authData = new AuthData(securityGroups);

const AdminQRLogin = () => {
    const notifyRef = useRef();
    const [mfaCode, setMfaCode] = useState();
    const [showSecret, setShowSecret] = useState(false);
    const history = useHistory();
 
    const [qrData,setQrData] = useState({})
    const [session,setSession] = useState()

   
    const AuthCtl = useMemo(() => new Auth(authData.token), [authData.token]);


    useEffect(() => {
        try {
            const storedData = localStorage.getItem("QRdataAdmin");
            if (storedData) {
                setQrData(JSON.parse(storedData));
            }
        } catch (error) {
            console.error("Error parsing QR data:", error);
            setQrData({}); // Set default empty object to avoid crashes
        }
    }, []);

    useEffect(() => {
        try {
            const sessionData = localStorage.getItem("session");
            if (sessionData) {
                setSession(JSON.parse(sessionData));
            }
        } catch (error) {
            console.error("Error parsing session data:", error);
            setSession(null); // Fallback to null to prevent crashes
        }
    }, []);

    const handleVerifyTotpAdmin = () => {
        if (qrData?.qrCode) {
            let body = {
                totp: mfaCode,
                requestType: "ENABLE_REQUEST",
                username: qrData?.username,
                accessToken: qrData?.accessToken,
                session: session
            };
    
            AuthCtl.enableTOTP(body, (data) => {
                if (data && !data.error) {
                    // if (QRData) {
                    //     delete QRData.qrCode;
                    //     delete QRData.qrCodeText;
                    //     delete QRData.challengeName;
                    //     delete QRData.accessToken;
                    //     localStorage.setItem("QRdataAdmin", JSON.stringify(QRData));
                    // }
                    setQrData((prev) => {
                        const { qrCode, qrCodeText, ...rest } = prev; // Remove only `qrCode` and `qrCodeText`
                        return rest;
                    });
                    Notify(notifyRef, "success", "TOTP Authentication successfully done");
                } else {
                    Notify(notifyRef, "danger", data?.errormessage ?? data?.error);
                }
            });
        } else {
            let body = {
                totp: mfaCode,
                requestType: "VERIFY_REQUEST",
                username: qrData?.username,
                session: session
            };
    
            AuthCtl.enableTOTP(body, (data) => {
                if (data && !data.error) {
                    localStorage.removeItem("QRdataAdmin");
                    Notify(notifyRef, "success", "Login Successfully");
    
                    
                    if (data?.accessToken) 
                        { const tokenValidator = new AuthData(securityGroups, true); tokenValidator.setToken(data.accessToken)
                        sessionStorage.setItem("accessToken", JSON.stringify( { token: `Bearer ${data?.accessToken}`, securityGroup: securityGroups, decodedToken: tokenValidator.decodedToken }));
                        localStorage.setItem("accessToken", data?.accessToken);
                        setTimeout(() => { history.replace("/admin/dashboard"); }, 500);
                     } // Small delay to ensure token is saved }
                } else {
                    Notify(notifyRef, "danger", data?.errormessage ?? data?.error);
                }
            });
        }
    };

    return (
        <>
             <ReactNotificationAlert ref={notifyRef} />
            <Row className="mb-5">
                <Col className="header py-7 py-lg-8">
                    <Container>
                        <div className="header-body text-center mb-7">
                            <Row className="justify-content-center">
                                <Col lg="12" md="10">
                                    <h1 className="text-black-50">Welcome to Ncentiva Management Platform!</h1>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </Col>
            </Row>
            {qrData?.qrCode ?
                <>
                    <Row className="justify-content-center">
                <Col lg="6" md="10">
                    <MotionCard initial={{ scale: 0.2, opacity: 0.3, rotateZ: 75 }} animate={{ scale: 1, opacity: 1, rotateZ: 0, transition: { type: "spring" } }} className="bg-light shadow border-0 overflow-hidden">
                        <Container className="py-4 pl-3">
                            <Row className="mb-4">
                                <Col className="text-center mx-3">
                                    <h4 className='my-0 fw-bold'>Set up your authenticator app</h4>
                                    <p className="text-muted">
                                        A virtual MFA device is an application running on your device that
                                        you can configure by scanning a QR Code.
                                    </p>
                                </Col>
                            </Row>

                            {/* Step 1 */}
                            <Row className="mb-4" style={{ margin: "10px" }}>
                                <Col xs={2} sm={1} className="d-flex align-items-center justify-content-center">
                                    <div className="circle fw-bold">1</div>
                                </Col>
                                <Col xs={10} sm={11}>
                                    <p className='my-0'>
                                        Install a compatible application such as Google Authenticator, Duo
                                        Mobile, or Authy app on your mobile device or computer.
                                    </p>
                                </Col>
                            </Row>

                            {/* Step 2 */}
                            <Row style={{ margin: "10px" }}>
                                <Col xs={2} sm={1} className="d-flex align-items-center justify-content-center">
                                    <div className="circle fw-bold">2</div>
                                </Col>
                                <Col xs={10} sm={11}>
                                    <Row>
                                        <Col md={4} className="">
                                            <Card style={{ backgroundColor: "#E0F0FF" }}>
                                               <Card.Body className="d-flex align-items-center justify-content-center" style={{padding:"0px"}}>
                                                <div className="border d-flex align-items-center justify-content-center" >
                                                {qrData?.qrCode ? (
                                                    <img src={`data:image/png;base64,${qrData.qrCode}`} alt="QR Code" style={{ width: "100%", height: "100%" }} />
                                                ) : (
                                                    <p>Loading QR code...</p>
                                                )}
                                                 </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col md={8} className='d-flex align-items-center flex-row'>
                                            <p>
                                                Open your authenticator app, choose Show QR code on this page,
                                                then use the app to scan the code. Alternatively, you can type a
                                                secret key.{" "}
                                                <a style={{ color: "#2665F2", fontWeight: "bold", cursor: "pointer" }} onClick={()=>setShowSecret(!showSecret)}>
                                                 {showSecret ? "Hide secret key" :"Show secret key"}   
                                                </a>
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                            <Col xs={6} sm={8} md={7} xxl={9} className >
                            {
                            showSecret ? 
                            <p style={{fontWeight:"500"}}> Secret Key: {qrData?.qrCodeText}</p>
                            :""
                           }
                        </Col>
                                                            
                                                        </Row>
                            <Row className="mb-4" style={{ margin: "10px" }}>
                                <Col xs={2} sm={1} className="d-flex align-items-center justify-content-center">
                                    <div className="circle fw-bold" style={{ marginBottom: "18px" }}>3</div>
                                </Col>
                                <Col xs={10} sm={11}>
                                    <Form>
                                        <Form.Group controlId="mfaCode">
                                            <Form.Label style={{ fontSize: "15px" }}>Enter your 6 digit code:</Form.Label>
                                            <p style={{ fontSize: "15px", margin: "0px" }}>MFA Code</p>
                                            <Form.Control type="text" placeholder="Enter your 6 digit MFA code" className="w-50" value={mfaCode} onChange={(e) => setMfaCode(e.target.value)}/>
                                        </Form.Group>
                                        <button className="mt-3 btn btn-primaryTwo" type='button' onClick={handleVerifyTotpAdmin}>
                                            Submit
                                        </button>
                                    </Form>
                                </Col>
                            </Row>
                        </Container>
                    </MotionCard>
                </Col>
            </Row>
                </>
                :
                // <div className="col-lg-6">
                //         <div className="authRight h-100 p-4 p-lg-5">
                //           <div className="authRightContent">
                //           <h3>Enter OTP Code </h3>
                //           <h6 className='mb-4 fs-6 fw-semi'>Your code has been sent to your Authentication App</h6>


                            // <div className="formField ">
                            //   <InputGroup className="mb-3">
                            //     <InputGroup.Text id="basic-addon1"><i className='bx bxs-lock-open'></i></InputGroup.Text>
                            //     <Form.Control
                            //       placeholder="Enter your OTP for verification"
                            //       aria-label="OTP"
                            //       aria-describedby="basic-addon1"
                            //       type='number'
                            //       value={mfaCode}
                            //       onChange={(e) => setMfaCode(e.target.value)}
                            //     //   className={otpError && 'border-danger'}

                            //     />
                            //   </InputGroup>
                            // </div>
                //             {/* {otpError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{otpError}</p>} */}
                //             <div className="text-end mb-4">

                //             </div>
                //             {/* {verifyLoader ? 
                //              <button className='btn btn-primaryTwo w-100'  disabled >
                //                Verifying...
                //               <Spinner
                //                     as="span"
                //                     animation="border"
                //                     size="sm"
                //                     role="status"
                //                     aria-hidden="true"
                //                   />

                //               </button>
                //               : */}
                //               <button className='btn btn-primaryTwo w-100' onClick={handleVerifyTotpAdmin} >Verify</button>
                //           {/* } */}

                //           </div>
                //         </div>
                // </div>


                <div
                    className="modal show"
                    style={{ display: 'block', position: 'initial' }}
                >
                    <Modal.Dialog>
                        <Modal.Header style={{backgroundColor:"#2665f2", display:"flex", justifyContent:"center"}}>
                            <Modal.Title className='m-0 text-white' style={{fontSize:"14px"}}>Please enter the code you received</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                        <div className="formField ">
                              <InputGroup className="mb-3 mt-1">
                                <InputGroup.Text id="basic-addon1"><i className='bx bxs-lock-open'></i></InputGroup.Text>
                                <Form.Control
                                  placeholder="Enter your OTP for verification"
                                  aria-label="OTP"
                                  aria-describedby="basic-addon1"
                                  type='number'
                                  value={mfaCode}
                                  onChange={(e) => setMfaCode(e.target.value)}
                                //   className={otpError && 'border-danger'}

                                />
                              </InputGroup>
                            </div>
                        </Modal.Body>

                        <Modal.Footer className='border-0 text-center d-flex justify-content-center pt-0'>
                            <button className='btn btn-primaryTwo mb-3 mt-0' onClick={handleVerifyTotpAdmin}>Verify</button>
                        </Modal.Footer>
                    </Modal.Dialog>
                </div>



            }
        </>
    );
};

export default AdminQRLogin